import { render } from "./BaseRadioGroup.vue?vue&type=template&id=0e349749&scoped=true&lang=pug"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import "./BaseRadioGroup.vue?vue&type=style&index=0&id=0e349749&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e349749"]])

export default __exports__